<template>
  <div class="page container-fluid h-100">
    <div class="row no-gutters h-100">
      <b-link :to="{name: 'CzlonekZespolu', params: {name: member.link} }" class="team-member row no-gutters w-100 d-flex" v-for="(member, index) in team" :key="member.link" :class="{'flex-row-reverse': index % 2 !== 0, 'flex-row': index % 2 === 0 }">
        <div
          class="team-member-image col-md-6 no-padding"
          v-bind:style="{ 'background-image': 'url(' + member.image2 + ')' }"
        >
          <img :src="member.image2" class="d-none">
        </div>
        <div class="team-member-description col-md-6">
          <h1>{{ member.name }}</h1>
          <p v-html="member.description">{{member.description}}</p>
          <b-button href="#" class="contact">Kontakt</b-button>
        </div>
      </b-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "Specjalizacja",
  data() {
    return {
    };
  },
  computed: {
    team() {
      return this.$store.state.teamMembers;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.page {
  padding: 0;
  margin: 0;
  overflow: hidden;
  min-height: 800px;
}
.team-member {
  box-sizing: border-box;
}
.team-member-image {
  background-position: center center;
  background-size: cover;
  min-height: 300px;
  order: 1;
}
.team-member-description {
  background: #292a2b;
  padding: 2rem;
  color: #e6ebf2;
  text-align: center;
  box-sizing: border-box;
  order:2;
}
.team-member-description h1 {
  color: #e6ebf2;
  font-size: 5rem;
  text-align: center;
  text-transform: uppercase;
}
.team-member-description h1::after {
  content: "";
  height: 0.1rem;
  background: #e6ebf2;
  width: 80%;
  margin: 1.5rem auto;
  display: block;
}
.team-member-description .btn.contact {
  border:1px solid #e6ebf2;
  background:none;
  border-radius:0.5rem;
  color:#e6ebf2;
  text-transform:uppercase;
  padding:1rem 2rem;
  font-size:1.5rem;
}
</style>